import i18n from "i18next"
import detector from "i18next-browser-languagedetector"
import { reactI18nextModule } from "react-i18next"
import translationEN from './locales/en/translation.json'
import translationDE from './locales/de/translation.json'
import translationVI from './locales/vi/translation.json'

const resources = {
    "en": {
        translation: translationEN
    },
    "de": {
        transition: translationDE
    }
}

i18n
    .use(detector)
    .use(reactI18nextModule) // passed i18n down to react-i18next
    .init({
        resources: {
            en: {
                translation: translationEN,
                //  {
                //     "Welcome to React": "Welcome to React and react-i18next"
                // }
            },
            de: {
                translation: translationDE 
                // {
                //     "Welcome to React": "Willkommen bei react und react-i18next"
                // }
            },
            vi: {
                translation: translationVI
            }
        },
        lng: "en",
        fallbackLng: "en",
        //keySeparator: false, // we do not use keys in form messages.welcome
        interpolation: {
            escapeValue: false // react already safes from xss
        }
    })

//     i18n
// //   .use(detector)
//   .use(reactI18nextModule) // passes i18n down to react-i18next
//   .init({
//     resources,
//    // fallbackLng: "en", // use en if detected lng is not available
//    //lng: "en",
//     keySeparator: false, // we do not use keys in form messages.welcome

//     interpolation: {
//       escapeValue: false // react already safes from xss
//     }
//   });

export default i18n;